import React from "react";

import { Box, NewIcon as Icon, Typography } from "@bca/ui-library";

const OutstandingChargesMessage: React.FunctionComponent = () => {
  return (
    <Box marginTop={4} marginBottom={4}>
      <Box display="flex" alignItems="center" marginBottom={1}>
        <Icon name="info" size="md" marginRight="xxs" />
        <Typography variant="h6" margin={0}>
          Please read
        </Typography>
      </Box>
      <Box as="ul" paddingLeft={6} marginY={2}>
        <Box as="li" marginBottom={1}>
          <Typography margin={0}>
            Any <strong>outstanding fees</strong> must be paid before your
            collection booking can be confirmed.
          </Typography>
        </Box>
        <Box as="li">
          <Typography margin={0}>
            We accept payment via <strong>Debit Card</strong> or{" "}
            <strong>Open Banking</strong>. However if you have already paid by{" "}
            <strong>Bank Transfer</strong>, please wait{" "}
            <strong>30 minutes</strong> before booking collection to allow time
            for your payment to be processed.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default OutstandingChargesMessage;
